<template>
  <div class="mb-5 md:mb-10 text-center px-8">
    <div
      class="
        rounded-full
        w-25
        h-25
        flex
        items-center
        justify-center
        mx-auto
        mb-4
      "
    >
      <img alt="Image decoration" :src="imgSrc" class="flex-shrink-0" />
    </div>
    <h2 class="last:mb-0 md:text-4xl">
      <slot name="header"></slot>
    </h2>
    <div
      class="text-editor font-normal text-base md:text-2xl lg:w-2/3 lg:px-10 mx-auto lg:leading-10 lg:-mt-2.5"
      v-if="$slots.body"
    >
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: String
  }
};
</script>
